import { destType, getObjectTypeAndId } from './objectType';

const imageSizes = [180, 190, 200, 280, 282, 400, 470, 650, 930, 1200, 1980];
const pixelRatios = [1, 1.5, 2];

function getClosestValue(baseValue, candidates) {
    let i = candidates.length;
    let selectedVal = candidates[i - 1];

    baseValue = parseFloat(baseValue);

    while (i--) {
        if (baseValue <= candidates[i]) {
            selectedVal = candidates[i];
        }
    }

    return selectedVal;
}

function estabIdToPath(estabId) {
    return estabId.toString().split('').join('/');
}

export function getImageDomain() {
    return `https://${TRPCONFIG.Domain.PhotoDomains}`;
}

export function getImageUrl(estabId, width, height, sequence, crop) {
    if (TRPCONFIG.Domain.HotelImageCDN) {
        return `https://${TRPCONFIG.Domain.HotelImageCDN}/images/hotels/${estabId}/${sequence}?width=${width}&height=${height}&crop=${!!crop}`;
    }
    let url = `${getImageDomain()}/ei/${estabIdToPath(estabId)}/${sequence}_${width}_${height}`;
    if (crop) {
        url += '_c';
    }
    return `${url}.jpg`;
}

export function getMainImageUrl(estabId, width, height, crop) {
    return getImageUrl(estabId, width, height, 0, crop);
}

export function getLandingPageImage(d) {
    if (d == null) {
        return null;
    }

    const [w] = getAppropriateSize($(window).width());

    if (TRPCONFIG.Domain.DeviceType !== 'Mobile') {
        const objectTypeAndId = getObjectTypeAndId(d);
        if (objectTypeAndId.Type === destType.Estab) {
            return getImageUrl(
                objectTypeAndId.Id,
                TRPCONFIG.DeviceSettings.LandingImageHeight,
                w,
                1,
                false
            );
        }
    }

    return getDestinationImage(d, w, TRPCONFIG.DeviceSettings.LandingImageHeight);
}

export function getDestinationImage(destination, width, height) {
    const IMG_API = `${TRPCONFIG.DestinationImagesClientDomain}/api2/destination/images/getfromobject`;
    const objectTypeAndId = getObjectTypeAndId(destination);
    const params = new URLSearchParams();
    params.set('v', TRPCONFIG.CurrentVersion);
    for (const key in objectTypeAndId) {
        params.set(key, objectTypeAndId[key]);
    }
    // only apply width and height if specified
    // if used, lazy-src directive will overwrite these
    if (width) {
        params.set('width', width);
    }
    if (height) {
        params.set('height', height);
    }
    return `${IMG_API}?${params}`;
}

export function getAppropriateSize(...size) {
    const pr = getClosestValue((window.devicePixelRatio || 1), pixelRatios);
    return size.map(s => getClosestValue(s, imageSizes) * pr);
}
